import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { Candidates } from '@/features/candidates'

const candidatesSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(50),
  filter: z.string().optional().catch(''),
  hasEmail: z.boolean().optional(),
  hasPhone: z.boolean().optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  sources: z.string().optional(),
})

export type CandidatesSearchParams = z.infer<typeof candidatesSearchSchema>

export const Route = createFileRoute('/_authenticated/candidates/')({
  validateSearch: candidatesSearchSchema,
  component: Candidates,
})
